<template>
  <div class="relative">
    <div
      class="absolute top-0 left-0 right-0 -mt-4 flex items-center justify-center"
    >
      <c-icon name="LocationOnFilled" size="3rem" />
    </div>
    <div id="gameContainer" class="h-[300px]" @click="spinToWin"></div>
  </div>
</template>

<script>
import { Wheel } from "https://cdn.jsdelivr.net/npm/spin-wheel@5.0.2/dist/spin-wheel-esm.js";
import CIcon from "../../../core-ui/src/components/CIcon.vue";
import { mapState } from "pinia";
import { authStore } from "../stores/auth";

export default {
  name: "SpinWheelGame",
  data() {
    return {
      wheel: null,
      spinned: false,
    };
  },
  props: {
    game: {
      type: Object,
      default: () => ({}),
    },
    gameParticipation: {
      type: Object,
      default: () => ({}),
    },
    promotionsById: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    let portions = this.game.coupons
      .map((c) => {
        return {
          label: c.couponPromotionId
            ? this.promotionsById[c.couponPromotionId]?.name.substring(0, 10)
            : "",
        };
      })
      .concat([
        {
          label: this.$t("no-prize-no-emoji"),
        },
      ]);
    let that = this;
    const props = {
      items: portions.length < 7 ? [...portions, ...portions] : portions,
      isInteractive: false,
      borderWidth: 5,
      lineWidth: 3,
      pixelRatio: 2,
      itemBackgroundColors: [
        this.branding.accentColor,
        this.branding.secondaryColor,
      ],
      itemLabelAlign: "right",
      itemLabelColors: [
        this.$utils.colorIsDark(this.branding.accentColor)
          ? "#FFFFFF"
          : "#000000",
        this.$utils.colorIsDark(this.branding.secondaryColor)
          ? "#FFFFFF"
          : "#000000",
      ],
      onRest: () => {
        that.$emit("spinFinished");
      },
    };

    // 2. Decide where you want it to go:
    const container = document.getElementById("gameContainer");

    // 3. Create the wheel in the container and initialise it with the props:
    this.wheel = new Wheel(container, props);
  },
  methods: {
    spinToWin() {
      if (this.spinned) {
        return;
      }
      this.spinned = true;
      let indexToSpin = this.gameParticipation.couponPromotionId
        ? this.game.coupons.findIndex(
            (c) =>
              c.couponPromotionId === this.gameParticipation.couponPromotionId
          )
        : this.game.coupons.length;
      this.wheel.spinToItem(indexToSpin, 3000, true, 3, 1, null);
    },
  },
  computed: {
    ...mapState(authStore, ["branding"]),
  },
  components: {
    CIcon,
  },
};
</script>

<style scoped></style>
